import SectionAlias from './SectionAlias';

export default SectionAlias;
